import { Button } from "@ui/components/forms/button/Button";
import { forwardRef, type ReactElement } from "react";

import { topFilterStyles, subFilterStyles, commonFilterStyles } from "./filterButton.styles";

//if the text conveys enough information for a screen reader a label is unneeded
type FilterButtonProps = {
    id: string;
    onClick: () => void;
    icon: ReactElement;
    iconPlacement: "right" | "left";
    label?: string;
    text: string;
    type: "top" | "secondary";
};

export const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>(
    function FilterButton(props, ref) {
        const { type, iconPlacement, label, id, icon, onClick, text } = props;
        const filterButtonStyles = type === "top" ? topFilterStyles : subFilterStyles;
        return (
            <Button
                ref={ref}
                onClick={onClick}
                id={id}
                sx={{
                    ...filterButtonStyles,
                    ...commonFilterStyles,
                }}
                variant="standard"
                rightIcon={iconPlacement === "right" ? icon : undefined}
                leftIcon={iconPlacement === "left" ? icon : undefined}
                aria-label={label}
                height={10}
            >
                <span>{text}</span>
            </Button>
        );
    }
);
